export default {
  categories: {
    shoes: "Zapatos",
    hoodies: "Sudaderas",
    tshirts: "Camisetas",
    jackets: "Chaquetas",
    pants: "Pantalones/Shorts",
    headwear: "Gorros",
    sets: "Conjuntos",
    underwear: "Ropa interior",
    jersey: "Camiseta deportiva",
    accessories: "Accesorios",
    bags: "Bolsos",
    belts: "Cinturones",
    perfumes: "Perfumes",
    other: "Otras cosas",
  },
};